import { Descriptions } from 'antd';
import styled from 'styled-components';

export default styled(Descriptions)`
	// Add your styles here
`;
